import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Briefing from './pages/Briefing/Briefing';
import BriefingTampa from './pages/Briefing/BriefingTampa';
import BriefingKraft from './pages/Briefing/BriefingKraft';
import PrototipoForm from './pages/Prototipo/PrototipoForm';
import PaginaRepresentante from './pages/PaginaRepresentante/PaginaRepresentante';
import Briefing2 from './pages/Briefing 2.0/Briefing';
import BriefingTampa2 from './pages/Briefing 2.0/BriefingTampa';
import BriefingKraft2 from './pages/Briefing 2.0/BriefingKraft';
import { useEffect } from 'react';

function App() {
  useEffect(() => {
      let pagina = window.location.pathname;
      if (pagina !== '/representante') {
      // 1. Espera até o objeto customer estar completo
      const waitCustomer = setInterval(() => {
        const raw = localStorage.getItem('customer');
        if (!raw) return;
      
        const customer = JSON.parse(raw);
        if (!customer?.name || !customer?.email) return;
      
        clearInterval(waitCustomer); // já temos os dados: para o polling
      
        // 2. Injeta o script da Octadesk
        (function (o, c, t, a, d, e, s, k) {
          o.octadesk = o.octadesk || {};
          o.octadesk.chatOptions = {
            subDomain: a,
            showButton: d,
            openOnMessage: e,
            showFooterPoweredBy: k,
            hide: s,
          };
          const bd = c.body;
          const sc = c.createElement('script');
          sc.async = true;
          sc.src = t;
          bd.appendChild(sc);
        })(
          window,
          document,
          'https://cdn.octadesk.com/embed.js',
          'o159525-4ea', //  seu sub‑domínio
          'true',        //  showButton
          'true',        //  openOnMessage
          'false',       //  hide
          'false'        //  showFooterPoweredBy
        );
      
        // 3. Faz login assim que o chat estiver pronto
        const handleChatReady = () => {
          window.octadesk?.chat?.login({
            name: customer.name,
            email: customer.email,
          });
        };
      
        window.addEventListener('onOctaChatReady', handleChatReady);
      
        // 4. Limpeza
        const cleanup = () => {
          window.removeEventListener('onOctaChatReady', handleChatReady);
        };
        // Garante que a limpeza aconteça mesmo se o componente desmontar
        window.addEventListener('beforeunload', cleanup);
      }, 300);
    
      // Se o componente desmontar antes de achar o cliente, limpa o polling
      return () => clearInterval(waitCustomer);
    }
    }, []);

  return (
    <Router>
      <div>
        <Routes>
          <Route path="/" element={<Briefing />} />
          <Route path="/v2/" element={<Briefing2 />} />
          <Route path="/v2/kraft" element={<BriefingKraft2 />} />
          <Route path="/v2/tampa" element={<BriefingTampa2 />} />
          <Route path="/tampa" element={<BriefingTampa />} />
          <Route path='/kraft' element={<BriefingKraft />} />
          <Route path='/prototipo' element={<PrototipoForm />} />
          <Route path='/representante' element={<PaginaRepresentante />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
